export const BACK_URL_SERVICE = process.env.VUE_APP_BACK_SERVICE;
export const API_URL_SERVICE = process.env.VUE_APP_API_SERVICE;
export const BASE_PATH_APP = process.env.VUE_APP_BASE_PATH;
export const VERSION_APP = process.env.VUE_APP_VERSION;
export const APP_NAME = process.env.VUE_APP_NAME;
export const MERCADO_PAGO_PUBLIC_KEY = process.env.VUE_APP_PUBLIC_KEY_MERCADO_PAGO
export const DEFAULT_EMAIL_PAYMENT = process.env.VUE_APP_DEFAULT_EMAIL_PAYMENT
export const APP_PREFIX_AUTH = process.env.VUE_APP_PREFIX_AUTH
export const API_CEP = process.env.VUE_APP_API_BRASIL